"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderResourceGrid = exports.renderLoadMoreSection = exports.filterResourceCards = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _BoundedCard = _interopRequireDefault(require("../BoundedCard/BoundedCard"));
var _NonTimeBasedListEntriesMethods = require("../NonTimeBasedListEntries/NonTimeBasedListEntriesMethods");
var _NonTimeBasedListEntries = require("../NonTimeBasedListEntries/NonTimeBasedListEntries");
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Images Sizes here are the same when used in Bounded Cards to preserve the 3:2 image ratio
const resourceGridImageSizes = {
  desktop: {
    width: 272,
    height: 181,
    ratio: {
      width: 3,
      height: 2
    }
  },
  tablet: {
    width: 272,
    height: 181,
    ratio: {
      width: 3,
      height: 2
    }
  },
  mobile: {
    width: 525,
    height: 350,
    ratio: {
      width: 3,
      height: 2
    }
  }
};
const renderLoadMoreSection = (loadMoreCards, displayLoadMoreButton) => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "luna-resource-grid__load-more"
  }, displayLoadMoreButton && /*#__PURE__*/_react.default.createElement(_Button.default, {
    key: `button-load-more`,
    onClick: e => loadMoreCards(e)
  }, "Load more"));
};
exports.renderLoadMoreSection = renderLoadMoreSection;
const renderResourceGrid = function (resourceCards, functTest, displayCardText) {
  let type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "bounded_cards";
  if (resourceCards && resourceCards?.length > 0) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `luna-resource-grid resource-grid-${type}`
    }, functTest === true && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", null, `TOTAL CARDS: ` + resourceCards?.length), " ", /*#__PURE__*/_react.default.createElement("br", null)), resourceCards?.map((resourceCard, index) => {
      const ResourceCardContent = {
        image: resourceCard?.image,
        eyebrow: resourceCard?.eyebrow,
        header: resourceCard?.header,
        cardLink: resourceCard?.cardLink,
        imageSizes: resourceGridImageSizes,
        text: displayCardText ? resourceCard?.text : null,
        isFeatured: resourceCard?.isFeatured,
        featuredLabel: resourceCard?.featuredLabel
      };
      if (functTest === true) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, " ", resourceCard.header, " --", resourceCard.cardTags.map(tag => {
          return /*#__PURE__*/_react.default.createElement("span", {
            style: {
              border: "1px solid black",
              fontSize: "14px",
              display: "block"
            }
          }, tag.name + "  ");
        })));
      } else {
        if (type === "bounded_cards") {
          return /*#__PURE__*/_react.default.createElement(_BoundedCard.default, {
            key: index,
            content: ResourceCardContent
          });
        } else if (type === "non_time_based") {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "cards long-description "
          }, /*#__PURE__*/_react.default.createElement(_NonTimeBasedListEntriesMethods.LongDescriptionCard, {
            key: index,
            eyebrow: resourceCard?.eyebrow,
            header: resourceCard?.header,
            subhead: resourceCard?.subhead,
            link: resourceCard?.link,
            ariaLabel: resourceCard?.customAriaLabel,
            image: resourceCard?.image,
            summary: resourceCard?.summary,
            contentfulId: resourceCard.contentfulId
          }));
        }
      }
    }));
  }
};
exports.renderResourceGrid = renderResourceGrid;
const filterResourceCards = (cards, activeFilters) => {
  if (!cards || cards?.length === 0 || !cards?.length) {
    // if no cards, don't render anything
    return null;
  }
  if (activeFilters?.length < 1 || activeFilters === null) {
    // if no filters are set, just return all cards (default view)
    return cards;
  }
  let matchingCards = [];
  cards?.map(card => {
    let matchesTags;

    // add category property so we can group by it
    const filterValues = activeFilters?.map(filter => {
      return {
        ...filter,
        category: filter?.value.split("-")[0]
      };
    });

    // group active filters by category so we can loop through them
    const groupedActiveFilters = (0, _lodash.groupBy)(filterValues, "category");

    // arrange values in shallow array for easy comparison
    const shallowTagArray = [...card.cardTags?.map(filter => {
      return filter?.value;
    })];

    // loop through each category (topic, industry etc) and check if tags on current card match
    Object.entries(groupedActiveFilters)?.forEach(activeFilterGroup => {
      // flatten array of filter values for comparison
      const activeFilterOptions = activeFilterGroup[1]?.map(value => {
        return value?.value;
      });

      // only update matchesTags variable if not already false - if it's false, the card shouldn't be pushed to the grid array
      matchesTags = matchesTags != false ? activeFilterOptions?.some(item => shallowTagArray?.includes(item)) : false;
    });
    if (matchesTags === true) {
      matchingCards?.push(card);
    }
  });
  return matchingCards;
};
exports.filterResourceCards = filterResourceCards;